import React, { FC, useState } from "react";
import { Pressable } from "react-native";
import { Text, ActionSheet, View, Colors } from "react-native-ui-lib";
import { Entypo } from '@expo/vector-icons';

export type ConflictBadgeProps = {
    options: any[],
    activeIndex: number,
    setActiveIndex: (index: number) => void,
    optionTestIDs?: string[],
}

export const Dropdown: FC<ConflictBadgeProps> = (
    {
        options,
        activeIndex,
        setActiveIndex,
        optionTestIDs,
    }
) => {
    const [showDropdownOptions, setShowDropdownOptions] = useState(false);


    return (
        <>
            <Pressable
                onPress={() => setShowDropdownOptions(true)}>
                <View row style={{ alignItems: 'center', justifyContent: 'flex-end' }}>
                    <Text textSecondary style={{}}>
                        {options[activeIndex]}
                    </Text>
                    <Entypo name="chevron-small-down" size={24} color={Colors.textSecondary} />
                </View>
            </Pressable>
            <ActionSheet
                visible={showDropdownOptions}
                dialogStyle={{
                    borderTopLeftRadius: 30,
                    borderTopRightRadius: 30,
                    backgroundColor: Colors.quaternaryBG,
                }}
                options={options.map((option, index) =>
                ({
                    label: option,
                    testID: optionTestIDs?.[index],
                    onPress: () => {
                        setActiveIndex(index);
                    },
                }))
                }
                onDismiss={() => setShowDropdownOptions(false)}
            />
        </>

    )

}